export default __webpack_public_path__ + "static/media/Oliver_ParticleSmoke-35.c2b7e306.png";